import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const UspsDirectCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  customerRegistrationId: input<string>({ validator: nonEmptyValidator }),
  mailerId: input<string>({ validator: nonEmptyValidator }),
  manifestMailerId: input<string>({ validator: nonEmptyValidator }),
});

export type UspsDirectCarrierValue = InputSchema.Value<
  typeof UspsDirectCarrierInput
>;

export type UspsDirectCarrierForm = InputSchema.Input<
  typeof UspsDirectCarrierInput
>;

export const uspsDirectCarrierDefault = (): UspsDirectCarrierValue => ({
  accountNumber: "",
  customerRegistrationId: "",
  mailerId: "",
  manifestMailerId: "",
});

export const CreateUspsDirectCarrierForm = memo(
  function CreateUspsDirectCarrierForm({
    carrierInput,
  }: {
    carrierInput: UspsDirectCarrierForm;
  }) {
    return (
      <>
        <RedoTextInput
          description="The account number that will be used to pay for labels"
          label="EPS account number"
          placeholder="Enter EPS account number"
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="Customer registration ID (CRID)"
          placeholder="Enter customer registration ID"
          setValue={carrierInput.inputs.customerRegistrationId.setValue}
          value={carrierInput.inputs.customerRegistrationId.value}
        />
        <RedoTextInput
          label="Mailer ID (MID)"
          placeholder="Enter mailer ID"
          setValue={carrierInput.inputs.mailerId.setValue}
          value={carrierInput.inputs.mailerId.value}
        />
        <RedoTextInput
          label="Manifest mailer ID (Manifest MID)"
          placeholder="Enter manifest mailer ID"
          setValue={carrierInput.inputs.manifestMailerId.setValue}
          value={carrierInput.inputs.manifestMailerId.value}
        />
      </>
    );
  },
);
